import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { from, border, labs, space, textSans, } from '@guardian/source-foundations';
import { Dropdown } from '@root/src/web/components/Dropdown';
import LabsLogo from '@frontend/static/logos/the-guardian-labs.svg';
import { LinkButton, SvgArrowRightStraight, Link, } from '@guardian/source-react-components';
const Container = ({ children }) => (_jsx("div", Object.assign({ css: css `
			position: relative;
			height: 55px;
			display: flex;
			justify-content: space-between;
		` }, { children: children }), void 0));
const Left = ({ children }) => (_jsx("div", Object.assign({ css: css `
			display: flex;
		` }, { children: children }), void 0));
const Right = ({ children }) => (_jsx("div", Object.assign({ css: css `
			display: flex;
			padding: ${space[1]}px 0;
		` }, { children: children }), void 0));
const HeaderSection = ({ children, isFirst, }) => (_jsx("div", Object.assign({ css: css `
			border-right: 1px solid ${border.primary};
			height: 100%;
			display: flex;
			align-items: center;

			${isFirst ? null : 'padding-left: 10px;'}
			padding-right: 10px;
			${from.mobileLandscape} {
				${isFirst ? null : 'padding-left: 20px;'}
				padding-right: 20px;
			}
		` }, { children: children }), void 0));
const Title = () => (_jsx("div", Object.assign({ css: css `
			${textSans.small({ fontWeight: 'bold' })};
			margin-bottom: 4px;
		` }, { children: "Paid content" }), void 0));
const AboutDropdown = ({ children }) => (_jsx("div", Object.assign({ css: css `
			color: black;
			> button {
				${textSans.small()};
				color: black;
				:hover {
					color: black;
				}
			}
		` }, { children: children }), void 0));
const About = () => (_jsxs("div", Object.assign({ css: css `
			${textSans.small()};
			position: absolute;
			top: 55px;
			left: 0;
			background-color: ${labs[400]};
			border-top: 1px solid ${border.primary};

			width: 100vw;
			${from.desktop} {
				width: 235px;
			}

			margin-left: -10px;
			${from.mobileLandscape} {
				margin-left: -20px;
			}
			padding: ${space[2]}px 10px;
			${from.mobileLandscape} {
				padding: ${space[3]}px 20px;
			}

			> a {
				color: black;
			}
		` }, { children: [_jsx("p", { children: "Paid content is paid for and controlled by an advertiser and produced by the Guardian Labs team." }, void 0), _jsx("br", {}, void 0), _jsx(LinkButton, Object.assign({ iconSide: "right", size: "xsmall", priority: "subdued", icon: _jsx(SvgArrowRightStraight, {}, void 0), href: "https://www.theguardian.com/info/2016/jan/25/content-funding" }, { children: "Learn more" }), void 0)] }), void 0));
const Logo = () => (_jsx(Link, Object.assign({ href: "https://www.theguardian.com/guardian-labs" }, { children: _jsx(LabsLogo, {}, void 0) }), void 0));
export const LabsHeader = () => (_jsxs(Container, { children: [_jsxs(Left, { children: [_jsx(HeaderSection, Object.assign({ isFirst: true }, { children: _jsx(Title, {}, void 0) }), void 0), _jsx(HeaderSection, { children: _jsx(AboutDropdown, { children: _jsx(Dropdown, Object.assign({ label: "About", links: [], id: "paidfor", overrideColor: "black", dataLinkName: "" }, { children: _jsx(About, {}, void 0) }), void 0) }, void 0) }, void 0)] }, void 0), _jsx(Right, { children: _jsx(Logo, {}, void 0) }, void 0)] }, void 0));
